import { render, staticRenderFns } from "./InsightWidgetGrid.vue?vue&type=template&id=2e8bdbaa&scoped=true"
import script from "./InsightWidgetGrid.vue?vue&type=script&lang=js"
export * from "./InsightWidgetGrid.vue?vue&type=script&lang=js"
import style0 from "./InsightWidgetGrid.vue?vue&type=style&index=0&id=2e8bdbaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8bdbaa",
  null
  
)

export default component.exports